export const PERMANENT_TOAST_INTERVAL = -1;
